import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey1,
  grey10,
  purple1,
  purple8,
} from 'approot/shared/styles/colours.style';
import {
  borderRadius16,
  borderRadius8,
  standardFocusState,
  baseBoxShadowFocus,
  boxShadowBlack12,
} from 'approot/shared/styles/borders.style';
import { spacing8, spacing12 } from 'approot/shared/styles/spacing.style';
import { fontSize16, PStyled } from 'approot/shared/styles/typography.style';

export const RichtextHashtagDropdown = styled.div`
  ${boxShadowBlack12}

  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: ${grey1};
  border-radius: ${rem(borderRadius16)};
  padding: ${rem(spacing12)};
  width: ${rem(256)};
  z-index: 1000;
`;

type RichtextHashtagDropdownItemProps = {
  $isActive?: boolean;
};

export const RichtextHashtagDropdownItem = styled.button<RichtextHashtagDropdownItemProps>`
  ${standardFocusState}

  display: flex;
  align-items: center;
  background-color: ${grey1};
  border: 1px solid ${grey1};
  cursor: pointer;
  border-radius: ${rem(borderRadius8)};
  padding: ${rem(spacing8)} ${rem(spacing12)};
  color: ${grey10};
  text-align: left;
  font-size: ${rem(fontSize16)};
  margin-bottom: ${rem(2)};

  &:hover {
    background-color: ${purple1};
    color: ${purple8};
    cursor: pointer;
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    box-shadow: ${baseBoxShadowFocus};
  `}
`;

export const RichtextHashtagDropdownNoResult = styled(PStyled).attrs({
  marginBottom: 0,
  colour: grey10,
  secondaryText: true,
})`
  text-align: left;
  padding: ${rem(spacing8)} ${rem(spacing12)};
`;
